export class MissingInfoError extends Error {
  public name = 'MissingInfoError'
}
